/****************************************************
 * Module Name:  shapeMappingProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ShapeMappingProxy {
    static GetAllShapeMapping = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/shapemapping",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleShapeMapping = (shapeMappingId, callback) => {
        let params = {
            id: shapeMappingId,
        };

        restAPICall(
            Constants.UTILITY_URL + "/shapemapping",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckShapeMappingAvailable = (detailedShape, callback) => {
        let params = {
            detailedshape: detailedShape,
        };

        restAPICall(
            Constants.UTILITY_URL + "/shapemapping/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddShapeMapping = (shapemapping, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/shapemapping",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(shapemapping),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateShapeMapping = (shapemapping, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/shapemapping",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(shapemapping),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteShapeMapping = (shapemapping, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/shapemapping",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(shapemapping),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
